import toast from "./index.vue"

export default {
  install(Vue, options) {
    const Toast = Vue.extend(toast)
    let vm = new Toast().$mount(document.createElement("div"))
    vm.vm = vm
    let show = false

    function hide() {
      document.body.removeChild(vm.$el)
    }

    Vue.prototype.$toast = {
      show: ({
        header,
        headerDesc,
        arrow,
        position,
        title,
        text,
        width,
        textStyle,
        buttonCount,
        btnText,
        btnOK,
        btnCancel,
        btnCancelText
      }) => {
        console.log(this)
        if (show) {
          console.log("hide")
          hide()
        }
        show = true
        if (header !== undefined) {
          vm.header = header
        }
        if (headerDesc) {
          vm.headerDesc = headerDesc
        }
        if (position) {
          vm.position = position
        }
        if (title !== undefined) {
          vm.title = title
        }
        if (text) {
          vm.text = text
        }
        if (textStyle) {
          vm.textStyle = textStyle
        }
        if (buttonCount) {
          vm.buttonCount = buttonCount
        }
        if (btnText !== undefined) {
          vm.btnText = btnText
        }
        if (width) {
          vm.width = width
        }
        if (arrow !== undefined) {
          vm.arrow = arrow
        }
        if (btnOK) {
          vm.btnOK = btnOK
        }
        if (btnCancel) {
          vm.btnCancel = btnCancel
        }
        if (btnCancelText) {
          vm.btnCancelText = btnCancelText
        }
        document.body.appendChild(vm.$el)
      },
      hide() {
        show = false
        hide()
      }
    }
  }
}
